import React, { useState } from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import {
  BodyThree,
  SubtitleThree
} from '../../../../../../styles/theme/default/typography';
import { getImgixUrl } from '../../../../../../utils/helper';

const Wrapper = styled.div`
  padding: 20px;
  border-top: 1px solid #d8d8d8;
  padding-top: 20px;

  .title-open-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content-container {
    margin-top: 30px;
  }

  .dimensions-image {
    width: 100%;
    height: auto;
  }

  .dimensions-image-container {
    padding: 0;
    outline: none;
    border: none;
    margin: 0;
  }

  .dimensions-text {
    white-space: pre-line;
  }

  .details-container {
    margin-top: 35px;
  }

  .box-dimensions {
    border: none;
  }

  .no-border {
    border: none;
  }
`;

function Dimensions({
  productData,
  openByDefault,
  goToDimensionsImageSlide,
  isMobile
}) {
  const [open, setOpen] = useState(openByDefault);
  const isBedroomSets =
    productData?.frame?.primarySubcategory.category_id == 39;
  return (
    <Wrapper isMobile={isMobile}>
      <div className="title-open-btn" onClick={() => setOpen(!open)}>
        <SubtitleThree bold={true}>Dimensions</SubtitleThree>
        <Icon
          icon={`ti-arrow-${open ? 'up' : 'down'}`}
          size={12}
          color="black"
        />
      </div>
      {open && (
        <div className="content-container">
          {productData.frame.dimensions_image && (
            <button
              className="dimensions-image-container"
              disabled={isMobile}
              onClick={() => {
                if (!isMobile) {
                  goToDimensionsImageSlide();
                }
              }}
            >
              <Imgix
                className="dimensions-image"
                imgixParams={{ auto: 'compress,format' }}
                sizes="
                  (min-width: 992px) 640px,
                  95vw"
                src={getImgixUrl(productData.frame.dimensions_image)}
                htmlAttributes={{
                  alt: 'dimensions image',
                  loading: 'lazy'
                }}
              />
            </button>
          )}
          <div className="details-container">
            <ConstructionItem className={`${isBedroomSets ? 'no-border' : ''}`}>
              <BodyThree className="title">General Dimensions</BodyThree>
              <BodyThree color="#4B4B4B" className="content dimensions-text">
                {productData.frame.dimensions}
              </BodyThree>
            </ConstructionItem>

            {productData.frame.weight ? (
              <ConstructionItem>
                <BodyThree className="title">Weight</BodyThree>
                <BodyThree color="#4B4B4B" className="content">
                  {productData.frame.weight} lbs
                </BodyThree>
              </ConstructionItem>
            ) : (
              ''
            )}

            {productData.frame.weight_limit ? (
              <ConstructionItem>
                <BodyThree className="title">Weight Limit</BodyThree>
                <BodyThree color="#4B4B4B" className="content">
                  {productData.frame.weight_limit} lbs
                </BodyThree>
              </ConstructionItem>
            ) : (
              ''
            )}

            {productData.frame.box_dimensions && (
              <ConstructionItem className="box-dimensions">
                <BodyThree className="title">Box Dimensions</BodyThree>
                <BodyThree color="#4B4B4B" className="content">
                  {productData.frame.box_dimensions}
                </BodyThree>
              </ConstructionItem>
            )}
          </div>
        </div>
      )}
    </Wrapper>
  );
}

export default Dimensions;

const ConstructionItem = styled.div`
  display: flex;
  border-bottom: 1px solid #ececec;
  padding: 12px 0;
  .title {
    margin: 0;
    min-width: 210px;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    border-bottom: none;
  }
`;
